export default "__VITE_PUBLIC_ASSET__3efa912d__"